var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/input/Button.tsx";
import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import ButtonBase from './ButtonBase';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Render a button with a label (`children`) and optional icon
 */
const ButtonNext = function Button({
  children,
  classes,
  elementRef,
  expanded,
  pressed,
  title,
  icon: Icon,
  size = 'md',
  variant = 'secondary',
  ...htmlAttributes
}) {
  return _jsxDEV(ButtonBase, {
    "data-component": "Button",
    ...htmlAttributes,
    classes: classnames('focus-visible-ring transition-colors whitespace-nowrap flex items-center', 'font-semibold rounded-sm', {
      // Variants
      'text-grey-7 bg-grey-1 enabled:hover:text-grey-9 enabled:hover:bg-grey-2 aria-pressed:text-grey-9 aria-expanded:text-grey-9': variant === 'secondary',
      // default
      'text-grey-1 bg-grey-7 enabled:hover:bg-grey-8 disabled:text-grey-4': variant === 'primary'
    }, {
      // Sizes
      'p-2 gap-x-2': size === 'md',
      // default
      'p-1 gap-x-1': size === 'xs',
      'p-1.5 gap-x-1.5': size === 'sm',
      'p-2.5 gap-x-1.5': size === 'lg'
    }, classes),
    elementRef: downcastRef(elementRef),
    expanded: expanded,
    pressed: pressed,
    title: title,
    unstyled: true,
    children: [Icon && _jsxDEV(Icon, {
      className: "w-em h-em"
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 16
    }, this), children]
  }, void 0, true, {
    fileName: _jsxFileName,
    lineNumber: 43,
    columnNumber: 5
  }, this);
};
export default ButtonNext;
//# sourceMappingURL=Button.js.map